import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {

  async atualizarRoteiroVisita(axios, parametros) {        
    parametros.operacao = 'atualizarRoteiroVisita';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async excluirRoteiroVisita(axios, parametros) {        
    parametros.operacao = 'excluirRoteiroVisita';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async baixarRoteiroVisita(axios, parametros) {        
    parametros.operacao = 'baixarRoteiroVisita';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async atualizarItemRoteiroVisita(axios, parametros) {        
    parametros.operacao = 'atualizarItemRoteiroVisita';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async excluirItemRoteiroVisitas(axios, parametros) {        
    parametros.operacao = 'excluirItemRoteiroVisitas';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async registrarCheckIn(axios, parametros) {        
    parametros.operacao = 'registrarCheckIn';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async registrarCheckOut(axios, parametros) {        
    parametros.operacao = 'registrarCheckOut';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async salvarObservacao(axios, parametros) {        
    parametros.operacao = 'salvarObservacao';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async registrarFotoVisita(axios, parametros) {        
    parametros.operacao = 'registrarFotoVisita';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 60, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async excluirTodasFotosVisita(axios, parametros) {        
    parametros.operacao = 'excluirTodasFotosVisita';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async salvarObservacao(axios, parametros) {        
    parametros.operacao = 'salvarObservacao';   

    let retorno = {};

    await axios.santriPOST('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },


  async buscarRoteirosVisitas(axios, parametros) {        
    parametros.operacao = 'buscarRoteirosVisitas';   

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarObservacao(axios, parametros) {        
    parametros.operacao = 'buscarObservacao';   

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarAutorizacoes(axios, parametros) {        
    parametros.operacao = 'buscarAutorizacoes';   

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarItensRoteirosVisitas(axios, parametros) {        
    parametros.operacao = 'buscarItensRoteirosVisitas';   

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarRoteiroMaisRelevante(axios, parametros) {        
    parametros.operacao = 'buscarRoteiroMaisRelevante';   

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data.roteiro);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarFotosVisita(axios, parametros) {        
    parametros.operacao = 'buscarFotosVisita';   

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 60, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async verificacoesItemRoteiro(axios, parametros) {        
    parametros.operacao = 'verificacoesItemRoteiro'

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }, 

  async utilizaGerenciamentoCarteiras(axios, parametros) {        
    parametros.operacao = 'utilizaGerenciamentoCarteiras'

    let retorno = {};

    await axios.santriGET('/rest/roteiro', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }, 

}


// WEBPACK FOOTER //
// ./src/components/Rest/RRoteiro.js